import React, { useEffect, useContext } from "react";
import "./AboutPage.css";
import GurupranaliPhoto from "../assets/GuruPranali.jpg";
import SwamiSamarthPhoto from "../assets/Swami_Samarth.png";
import SadguruPithalePhoto from "../assets/om_image.jpg";
import SadguruMoredadaPhoto from "../assets/More Dada.png";
import GurumauliPhoto from "../assets/Mauli.png";
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import Header from "../components/Layout/Header";

// default fallback pattern
import DefaultPattern from "../assets/background.png";

const translations = {
  en: {
    header: "About",
    home: "Home",
    sections: [
      {
        year: "—",
        title: "Gurupranali & Seva Marg",
        points: [
          "Shri Swami Samarth Maharaj is the complete divine incarnation of Lord Dattatreya.",
          "He emphasized spiritual practice, faith, self-awareness, compassion, and goodwill towards all beings.",
          "He showed the simple path to worldly and spiritual happiness through ego renunciation, Guru devotion, remembrance of the Divine Name, and selfless Karma Yoga.",
          "Reviving Indian culture was the hallmark of His mission.",
        ],
        image: GurupranaliPhoto,
      },
      {
        year: "1856 – 1878",
        title: "Shree Swami Samarth Maharaj",
        points: [
          "Lived in Akkalkot for 22 years, guiding people spiritually and socially.",
          "Teachings focused on selfless service, surrender, and devotion to God.",
          "Life attains peace when ego is renounced and devotion, name remembrance, and service to humanity are practiced.",
          "In 1878, He took Samadhi; His mission continues worldwide.",
        ],
        image: SwamiSamarthPhoto,
      },
      {
        year: "1878 – 1974",
        title: "Brahmibhut tejonidhi Pithale Maharaj",
        points: [
          "Carried forward Swami Samarth Maharaj's teachings with devotion and discipline.",
          "Guided seekers with deep spiritual wisdom.",
          "Laid the foundation for continuation of the divine mission.",
        ],
        image: SadguruPithalePhoto,
      },
      {
        year: "1922 – 1988",
        title: "Sadguru Param Pujya Moredada",
        points: [
          "Established the 'Dindori Pranit Seva Marg'.",
          "Brought transformation through compassion, spiritual practice, and selfless service.",
          "Created a radiant path continuing Swami Maharaj's divine plan.",
        ],
        image: SadguruMoredadaPhoto,
      },
      {
        year: "1955 –  Present",
        title: "Param Pujya Gurumauli Annasaheb More",
        points: [
          "Leads the Gramsevak Abhiyan (Village Volunteer Movement).",
          "Over four decades, spearheaded social and spiritual reforms.",
          "Initiatives like de-addiction, women empowerment, and youth employment are carried out.",
          "With 7,000+ Seva Kendras worldwide, millions are guided towards service and welfare.",
        ],
        image: GurumauliPhoto,
      },
    ],
  },
  mr: {
    header: "आमच्याबद्दल",
    home: "मुख्यपृष्ठ",
    sections: [
      {
        year: "—",
        title: "गुरुप्रणाली & सेवा मार्ग",
        points: [
          "श्री स्वामी समर्थ महाराज हे संपूर्ण दैवी अवतार आहेत.",
          "त्यांनी आध्यात्मिक साधना, श्रद्धा, आत्म-जागरूकता, करुणा आणि सर्व जीवांवरील सद्भावना यावर भर दिला.",
          "अहंकार त्याग, गुरु भक्ती, दैवी नावाची स्मृती, आणि निस्वार्थ कर्मयोग यांद्वारे जीवनात साधेपणा आणि आनंद मिळतो.",
          "भारतीय संस्कृतीचा पुनरुज्जीवन हा त्यांच्या कार्याचा मुख्य उद्देश होता.",
        ],
        image: GurupranaliPhoto,
      },
      {
        year: "१८५६ – १८७८",
        title: "श्री स्वामी समर्थ महाराज",
        points: [
          "अक्कलकोटमध्ये २२ वर्षे राहिले, लोकांना आध्यात्मिक आणि सामाजिक मार्गदर्शन केले.",
          "त्यांच्या शिकवणीत निस्वार्थ सेवा, समर्पण, आणि देव भक्ती यांवर भर होता.",
          "अहंकाराचा त्याग आणि भक्ती, नाव स्मरण, मानवसेवा यांचा अभ्यास जीवनात शांतता आणि समाधान आणतो.",
          "१८७८ मध्ये त्यांनी समाधी घेतली; त्यांचा कार्य आजही हजारो सेवा केंद्रांद्वारे चालू आहे.",
        ],
        image: SwamiSamarthPhoto,
      },
      {
        year: "१८७८ – १९७४",
        title: "ब्रह्मीभूत तेजोनिधी पिठले महाराज",
        points: [
          "स्वामी समर्थ महाराजांच्या शिकवणींना भक्ती आणि शिस्तीसह पुढे नेले.",
          "शिष्यमंडळींना गहन आध्यात्मिक मार्गदर्शन दिले.",
          "दैवी मिशनच्या सतत चालू राहण्यासाठी पाया घालला.",
        ],
        image: SadguruPithalePhoto,
      },
      {
        year: "१९२२ – १९८८",
        title: "सद्गुरु परम पूज्य मोरेदादा",
        points: [
          "स्वामी समर्थ महाराजांच्या मिशनचा प्रसार करण्यासाठी 'दिंडोरी प्रणित सेवा मार्ग' स्थापन केले.",
          "करुणा, आध्यात्मिक साधना, आणि निस्वार्थ सेवेद्वारे परिवर्तन घडवले.",
          "स्वामी महाराजांच्या दैवी योजनेचा उजळ मार्ग तयार केला.",
        ],
        image: SadguruMoredadaPhoto,
      },
      {
        year: "१९५५ –  वर्तमान",
        title: "परम पूज्य गुरुमाऊली अण्णासाहेब मोरे",
        points: [
          "'२०% आध्यात्मिकता व ८०% सामाजिक सेवा' या तत्त्वावर ग्रामसेवक अभियान चालवले.",
          "चार दशकांहून अधिक सामाजिक आणि आध्यात्मिक सुधारणा केले.",
          "१८ विभागांतून नशामुक्ती, महिला सशक्तीकरण, तरुण रोजगार आणि समाजकल्याण उपक्रम चालवले.",
          "७,००० हून अधिक सेवा केंद्रांद्वारे हा मिशन लोकांना मूल्ये, सेवा आणि समाजकल्याणाकडे मार्गदर्शन करतो.",
        ],
        image: GurumauliPhoto,
      },
    ],
  },
};

export default function AboutPage() {
  const { lang } = useContext(LanguageContext);
  const t = translations[lang];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.15 }
    );

    const sections = document.querySelectorAll(".about-section");
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about-page">
      {/* Header */}
      <Header />

      {/* Page Header with Breadcrumb */}
      <div className="hospital-header">
        <div className="header-center">
          <div className="breadcrumb">
            <Link to="/">{t.home}</Link> &gt; <span>{t.header}</span>
          </div>
          <h1>{t.header}</h1>
        </div>
      </div>

      {/* Timeline */}
      <main className="about-main">
        <div className="timeline">
          {t.sections.map((section, index) => (
            <div
              key={index}
              className={`about-section ${index % 2 === 0 ? "left" : "right"}`}
            >
              <div className="about-card">
                <div className="year-label">{section.year}</div>
                
                <div className="about-card-content">
                  <div className="about-image">
                    {section.image ? (
                      <img src={section.image} alt={section.title} />
                    ) : (
                      <div
                        className="pattern-fallback"
                        style={{ backgroundImage: `url(${DefaultPattern})` }}
                      ></div>
                    )}
                  </div>
                  
                  <div className="about-info">
                    <h2>{section.title}</h2>
                    <ul>
                      {section.points.map((point, idx) => (
                        <li key={idx}>{point}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}